var isResolved = location => location.name !== undefined;
var populateNameFromFilters = filters => filters.getLocalities().filter(isResolved).map(location => ({
  name: location.name
}));
export var generateAlertName = searchQuery => {
  if (searchQuery.isMapSearch()) {
    return 'Map Area';
  }
  var localities = populateNameFromFilters(searchQuery.filters) || [];
  var summary = '';
  if (localities.length) {
    summary = localities[0].name;
    if (localities.length > 1) {
      var remaining = localities.length - 1;
      var suffix = remaining === 1 ? 'location' : 'locations';
      summary += " + ".concat(remaining, " ").concat(suffix);
    }
  }
  return summary;
};